import React from 'react';
import { useTranslation } from 'react-i18next';

const AuthActionButton = ({ onClick, authState }) => {
  const { t } = useTranslation();

  return (
    <button className={'button-default mobile-auth-button'} onClick={onClick}>
      <span className={'icon-group'}>
        <i className={`icon ${authState ? 'icon-bold-logout' : 'icon-bold-person'}`} />
      </span>
      <span className={'auth-text'}>{authState ? t('logout') : t('login')}</span>
    </button>
  );
};

export default AuthActionButton;
